<span
  [ngClass]="{
    'socket-indicator socket-connected': (usingLocalStorage$ | async) === false,
    'text-danger mdi mdi-alpha-x-circle-outline': (usingLocalStorage$ | async)
  }"
  [ngbTooltip]="usingLocalStorageTooltip$ | async"
  placement="top-right"
  >Storage</span
>
<span
  *ngIf="activeSession != null"
  [ngClass]="{
    'socket-indicator socket-connected': messaging.isSessionConnected$ | async,
    'text-danger mdi mdi-alpha-x-circle-outline':
      (messaging.isSessionConnected$ | async) === false
  }"
  [ngbTooltip]="
    'Session socket status: ' +
    ((messaging.isSessionConnected$ | async) ? 'Connected' : 'Disconnected')
  "
  placement="top-right"
  >Session</span
>
<span
  [ngClass]="{
    'socket-indicator socket-connected': messaging.isGlobalConnected$ | async,
    'text-danger mdi mdi-alpha-x-circle-outline':
      (messaging.isGlobalConnected$ | async) === false
  }"
  [ngbTooltip]="
    'Global socket status: ' +
    ((messaging.isGlobalConnected$ | async) ? 'Connected' : 'Disconnected')
  "
  placement="top-right"
  >Global</span
>
<div class="banner" *ngIf="!globalSocketConnected">
  <div class="banner-content">
    <div class="banner-text">
      <span class="mdi mdi-information-outline"></span>
      <span
        >Global socket disconnected - Please check your network connection and
        refresh your page</span
      >
    </div>
    <button class="btn btn-link" (click)="globalSocketConnected = true">
      <span class="mdi mdi-close"></span>
    </button>
  </div>
</div>
